/**
 * Background Music presets by editorial series.
 * Each series has a fixed BGM loop with volume and duck settings.
 * Used with AudioTrack component for automatic speech ducking.
 */

export const SERIES_BGM: Record<string, {
  file: string;
  volume: number;
  duckVolume: number;
  fadeInSeconds: number;
  fadeOutSeconds: number;
}> = {
  "cafe-com-teu-roi": {
    file: "music/cafe-lofi.mp3",
    volume: 0.12,
    duckVolume: 0.04,
    fadeInSeconds: 2,
    fadeOutSeconds: 3,
  },
  "verdades-dificeis": {
    file: "music/verdade-tension.mp3",
    volume: 0.10,
    duckVolume: 0.03,
    fadeInSeconds: 1.5,
    fadeOutSeconds: 3,
  },
  "aprendi-errando": {
    file: "music/aprendi-emotional.mp3",
    volume: 0.08,
    duckVolume: 0.03,
    fadeInSeconds: 2,
    fadeOutSeconds: 4,
  },
  "perguntas": {
    file: "music/perguntas-corporate.mp3",
    volume: 0.10,
    duckVolume: 0.03,
    fadeInSeconds: 1.5,
    fadeOutSeconds: 3,
  },
  "quiz": {
    file: "music/quiz-energy.mp3",
    volume: 0.18,
    duckVolume: 0.06,
    fadeInSeconds: 1,
    fadeOutSeconds: 2,
  },
} as const;

/** Convert scene array to ducking segments for AudioTrack */
export function scenesToDuckSegments(
  scenes: Array<{dur: number}>,
  fps: number,
): Array<{startSeconds: number; endSeconds: number}> {
  let offset = 0;
  return scenes.map(({dur}) => {
    const start = offset / fps;
    offset += dur;
    const end = offset / fps;
    return {startSeconds: start, endSeconds: end};
  });
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
